import { render, staticRenderFns } from "./withdraw.vue?vue&type=template&id=5624cf0a&scoped=true&"
import script from "./withdraw.vue?vue&type=script&lang=js&"
export * from "./withdraw.vue?vue&type=script&lang=js&"
import style0 from "./withdraw.vue?vue&type=style&index=0&id=5624cf0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624cf0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5624cf0a')) {
      api.createRecord('5624cf0a', component.options)
    } else {
      api.reload('5624cf0a', component.options)
    }
    module.hot.accept("./withdraw.vue?vue&type=template&id=5624cf0a&scoped=true&", function () {
      api.rerender('5624cf0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantMy/withdraw.vue"
export default component.exports